import {useState, useRef} from "react";
import {useTranslation} from "react-i18next";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DataRange from "components/datetime/DataRange";
import SearchSelect from "components/selects/SearchSelect";
import moment from "moment/moment";

const FormFiltersModel = {
    uid: "",
    uuid: "",
    waste_type: "",
    download_type: "",
    group: "",
    zone: "",
    route: "",
    island: "",
    start: "",
    end: "",
};

const UnloadsFilters = ({
    filters,
    // counter,
    // setCounter,
    params,
    applyFilters,
    setItemsShown,
    isLoading,
}) => {
    const {t: _Tt} = useTranslation("tags");
    const [dateRangeSelected, setDateRangeSelected] = useState();
    // -
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    const [formFilters, setFormFilters] = useState({...FormFiltersModel});
    const defaultRange = useRef({
        start: new Date(),
        end: new Date(),
        startString: "",
        endString: "",
    });

    useState(() => {
        defaultRange.current.start = defaultRange.current.start.setDate(
            defaultRange.current.start.getDate() - 6
        );
        defaultRange.current.startString = moment(defaultRange.current.start).format(
            "DD/MM/YYYY"
        );
        defaultRange.current.endString = moment(defaultRange.current.end).format(
            "DD/MM/YYYY"
        );

        setDateRangeSelected(
            `${defaultRange.current.startString} - ${defaultRange.current.endString}`
        );
        //setDateRange([defaultRange.current.start, defaultRange.current.end]);
        filters.current.start = defaultRange.current.startString;
        filters.current.end = defaultRange.current.endString;
    }, []);

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        setFormFilters({...formFilters, [name]: value});
        if (value) {
            filters.current[name] = value;
        } else {
            delete filters.current[name];
        }
    };

    const handleClearFilters = () => {
        filters.current = {};
        setFormFilters({...FormFiltersModel});
        setItemsShown([]);
        clearDateRange();
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;
        value = value.trim().toUpperCase();
        setFormFilters({...formFilters, [name]: value});
        filters.current[name] = value;
        if (value) {
            filters.current[name] = value;
        } else {
            delete filters.current[name];
        }
    };

    const selectDataRange = (start, end) => {
        //setDateRange([start, end]);
        const formattedStart = start ? moment(start).format("DD/MM/YYYY") : "";
        const formattedEnd = end ? moment(end).format("DD/MM/YYYY") : "";
        setDateRangeSelected(`${formattedStart} - ${formattedEnd}`);
        filters.current.start = formattedStart;
        filters.current.end = formattedEnd;
    };

    const clearDateRange = () => {
        const formattedStart = moment(defaultRange.current.start).format("DD/MM/YYYY");
        const formattedEnd = moment(defaultRange.current.end).format("DD/MM/YYYY");

        setDateRangeSelected(`${formattedStart} - ${formattedEnd}`);

        filters.current.start = formattedStart;
        filters.current.end = formattedEnd;
    };
    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    <Button
                        variant="link"
                        type="button"
                        onClick={handleClearFilters}
                        style={{color: "black"}}
                        className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("container.download_type")}
                        </label>
                        <DownloadTypesSelect
                            multiple={false}
                            value={formFilters.download_type}
                            onChange={onChangeSelect}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("container.waste_type")}
                        </label>
                        <WasteTypesSelect
                            multiple={false}
                            value={formFilters.waste_type}
                            onChange={onChangeSelect}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_Tt("common.group")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _Tt("common.all")},
                                ...params.groups.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={_Tt("common.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    group: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.group = option.value;
                                } else {
                                    delete filters.current.group;
                                }
                            }}
                            value={
                                params.groups
                                    .filter((g) => g.id === formFilters.group)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_Tt("common.zones")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _Tt("common.all")},
                                ...params.zones.map((z) => ({
                                    value: z.id,
                                    label: z.name,
                                })),
                            ]}
                            placeholder={_Tt("common.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    zone: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.zone = option.value;
                                } else {
                                    delete filters.current.zone;
                                }
                            }}
                            value={
                                params.zones
                                    .filter((z) => z.id === formFilters.zone)
                                    .map((z) => ({
                                        value: z.id,
                                        label: z.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_Tt("common.routes")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _Tt("common.all")},
                                ...params.routes.map((r) => ({
                                    value: r.id,
                                    label: r.name,
                                })),
                            ]}
                            placeholder={_Tt("common.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    route: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.route = option.value;
                                } else {
                                    delete filters.current.route;
                                }
                            }}
                            value={
                                params.routes
                                    .filter((r) => r.id === formFilters.route)
                                    .map((r) => ({
                                        value: r.id,
                                        label: r.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_Tt("common.islands")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _Tt("common.all")},
                                ...params.islands.map((i) => ({
                                    value: i.id,
                                    label: i.name,
                                })),
                            ]}
                            placeholder={_Tt("common.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    island: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.island = option.value;
                                } else {
                                    delete filters.current.island;
                                }
                            }}
                            value={
                                params.islands
                                    .filter((i) => i.id === formFilters.island)
                                    .map((i) => ({
                                        value: i.id,
                                        label: i.name,
                                    }))[0] || null
                            }
                        />
                    </div>

                    <div className="col pt-3 mt-2">
                        <button
                            type="button"
                            onClick={applyFilters}
                            className="btn btn-outline-primary me-3"
                            title="Aplicar"
                            disabled={isLoading}>
                            {isLoading ? (
                                <FontAwesomeIcon
                                    icon="circle-notch"
                                    className="fa-spin"
                                />
                            ) : (
                                <FontAwesomeIcon icon="magnifying-glass" />
                            )}{" "}
                            {_Tt("common.search")}
                        </button>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-1 h5 text-center"></div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>UID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uid"
                            value={formFilters.uid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>UUID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uuid"
                            value={formFilters.uuid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "260px"}}>
                        <label style={labelStyle}>{_Tt("common.date")}</label>
                        <ButtonGroup className="w-100">
                            <Dropdown className="w-100">
                                <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    style={{
                                        border: "1px solid #ced4da",
                                        minWidth: "100%",
                                    }}
                                    className="custom-dropdown-toggle">
                                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                    <label style={{width: "90%", textAlign: "center"}}>
                                        {dateRangeSelected}
                                    </label>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <DataRange
                                        rangeData={selectDataRange}
                                        maxSpan={30}
                                        maxDate={new Date()}
                                    />
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
                    </div>
                    <div className="col pt-3">
                        <div className="mt-3">
                            <FontAwesomeIcon
                                icon="info"
                                size="xl"
                                className="text-info me-2"
                            />{" "}
                            Click en celda para editar.
                        </div>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default UnloadsFilters;
